import React, { useState } from "react";
import { userService } from "../../services/user.service";
import notify from "devextreme/ui/notify";
import { useDispatch } from "react-redux";
import * as actions from '../../store/user/userActions';
import { ToastContainer } from "react-toastify";
import Footer from "../footer";
import { Link } from 'react-router-dom';
import { urlImg } from "../../data/app";
import { dialogLogin } from "../../store/login/loginDialogReducer";

function Login(props) {

    const dispatch = useDispatch();
    const [user, setUser] = useState({ username: "", password: "", verificationCode: "" });
    const [visible, setVisible] = useState(false);
    const [loading, setLoading] = useState(false);

    const onValueChange = e => {

        setUser({
            ...user,
            [e.target.name]: e.target.value
        });

    }

    const sendUser = e => {

        e.preventDefault();
        setLoading(true);
        userService.loginTwoFactor(user).then(userResp => {

            if (userResp.twoFactorRequired) {

                setVisible(true);
                setLoading(false);

            } else {
                auth(userResp);
            }

        }).catch(err => {
            setLoading(false);
            notify(err, "error");
        });

    }

    const auth = userResp => {

        console.log(userResp);  

        //let pathname = props?.location?.state?.from?.pathname || '/';

        if (userResp.mustToChangePass === true) {

            props.history.push({pathname:'/account/password',state: {
                reset: true
              }});

        }else{
            
            dispatch(actions.updateUser({ username: userResp.username }));
            dispatch(dialogLogin({ open: false }));
            props.history.push({ pathname: '/' });

        }
    }

    const verificar = () => {

        setLoading(true);

        userService.login(user).then(userResp => {

            auth(userResp);

        }).catch(err => {

            setVisible(false);
            setLoading(false);
            setUser({ ...user, verificationCode: null });

            notify(err, "error");

        });

    }

    const cancelar = (e) => {
        setVisible(false);
    }

    return (
        <React.Fragment>
            <ToastContainer autoClose={5000} hideProgressBar />
            <div className="login-continer">
                <div className="login-wrap">
                    <img className="img-login" src={urlImg} alt="" />
                </div>
                <div className="login-wrap">
                    <div className="wrapper-login">
                        <form className="form-signin" style={{ display: !visible ? 'block' : 'none' }} onSubmit={sendUser}>
                            <img className="nav-panel-logo" width={300} src={require('../../svg/logoclinica.png')} />
                            <div style={{ paddingTop: 80 }}>
                                <h4>Iniciar sesión</h4>
                                <input value={user.username} onChange={onValueChange} type="text" className="form-control" name="username" placeholder="Usuario" required autoFocus={true} />
                                <input value={user.password} onChange={onValueChange} type="password" className="form-control" name="password" placeholder="Contraseña" required />
                            </div>

                            <Link to={'/account/resetpassword'} >Olvide mi Contraseña</Link>
                            <br />
                            <input
                                className="btn btn-lg btn-primary btn-block"
                                type="submit"
                                value={loading ? "Iniciando..." : "Login"}
                                disabled={loading} />
                        </form>
                        <form className="form-signin" style={{ display: visible ? 'block' : 'none' }}>
                            <img className="nav-panel-logo" width={300} src={require('../../svg/logoclinica.png')} />
                            <div style={{ paddingTop: 80 }}>
                                <h5>Ingrese el codigo enviado</h5>
                                <input value={user.verificationCode} style={{ textAlign: 'center' }} onChange={onValueChange} type="text" className="form-control" name="verificationCode" placeholder="0000" required="" autoFocus={true} />
                            </div>
                            <button className="btn btn-lg btn-primary btn-block" type="button" disabled={loading} onClick={verificar}>{loading ? "Verificando..." : "Verificar"}</button>
                            <button className="btn btn-secondary btn-block" type="button" onClick={cancelar}>Cancelar</button>
                        </form>

                    </div>
                </div>
            </div>
            {/* 
            <footer className="site__footer">
                <Footer />
            </footer> */}
        </React.Fragment>
    );

}

export default Login;
